module.exports = __webpack_public_path__ + "img/bg_feature.d5deb674.svg";